import { useEffect, useRef } from "react";
import { restorePhoto } from "@/lib/photo";

const DB = "ms-signature";
const STORE = "drafts";

const openDb = () => new Promise((resolve, reject) => {
  const req = indexedDB.open(DB, 1);
  req.onupgradeneeded = () => req.result.createObjectStore(STORE);
  req.onsuccess = () => resolve(req.result);
  req.onerror = () => reject(req.error);
});

const tx = async (mode, fn) => {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const req = fn(t.objectStore(STORE));
    t.oncomplete = () => resolve(req?.result);
    t.onerror = () => reject(t.error);
  });
};

export const draftKey = (params) => `ms-draft2:${params.get("produit") || params.get("modele") || params.get("titre") || "libre"}`;

export const loadDraftCfg = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key)) || null;
  } catch {
    return null;
  }
};

export const saveDraftCfg = (key, cfg) => {
  try {
    localStorage.setItem(key, JSON.stringify(cfg));
  } catch {
    /* storage full or disabled */
  }
};

export const saveDraftPhoto = (key, slot, photo) =>
  tx("readwrite", (s) => (photo ? s.put({ original: photo.original, cutoutBlob: photo.cutoutBlob }, `${key}:${slot}`) : s.delete(`${key}:${slot}`))).catch(() => {});

export const loadDraftPhoto = (key, slot) => tx("readonly", (s) => s.get(`${key}:${slot}`)).catch(() => null);

export const clearDraft = (key, slots) => {
  localStorage.removeItem(key);
  return Promise.all(slots.map((slot) => saveDraftPhoto(key, slot, null)));
};

export const useConfigDraft = (key, cfg, photos, setPhotos) => {
  const saved = useRef({});
  useEffect(() => {
    let alive = true;
    Object.keys(photos).forEach(async (slot) => {
      const rec = await loadDraftPhoto(key, slot);
      if (!rec?.cutoutBlob || !alive) return;
      const p = await restorePhoto(rec);
      saved.current[slot] = p;
      setPhotos((ps) => (ps[slot] ? ps : { ...ps, [slot]: p }));
    });
    return () => { alive = false; };
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const t = setTimeout(() => saveDraftCfg(key, cfg), 300);
    return () => clearTimeout(t);
  }, [key, cfg]);

  useEffect(() => {
    Object.entries(photos).forEach(([slot, p]) => {
      if (!p || saved.current[slot] === p) return;
      saved.current[slot] = p;
      saveDraftPhoto(key, slot, p);
    });
  }, [key, photos]);
};
